import React, { useState } from 'react';
import Custombutton from '../../../../components/custombutton/custombutton';
import CustomTextField from '../../../../components/CustomTextInput';

export interface savetradedocumentProps {
    updateField: (name: string, value: any) => void;
    onSubmit: () => Promise<void>;
    loading: boolean;
    data?: any;
}

const Savetradedocument = ({
    updateField,
    onSubmit,
    loading,
    data
}: savetradedocumentProps) => {
    const [errors, setErrors] = useState({
        documentName: ''
    });
    const [payload, setPayload] = useState({
        documentName: data?.documentName || ''
    });

    const onSubmitting = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        <div className=' max-w-[95%] lg:max-w-none w-96 mx-auto '>
            <form
                autoComplete='off'
                onSubmit={onSubmitting}
                noValidate
                className='space-y-6 mt-6'
            >
                <CustomTextField
                    error={errors?.documentName.length > 0}
                    helperText={
                        errors?.documentName.length > 0
                            ? errors?.documentName
                            : undefined
                    }
                    required
                    value={payload?.documentName}
                    id='savedocument-documentName'
                    label='Name Tag'
                    name='documentName'
                    onChange={(e: any) => {
                        setPayload((prevState) => ({
                            ...prevState,

                            ['documentName']: e.target.value
                        }));
                        updateField('documentName', e.target.value);
                    }}
                />

                <Custombutton
                    isLoadingButton
                    loading={loading}
                    type='submit'
                    fullWidth
                    variant='contained'
                    styles={{
                        padding: '0.75rem 0.62rem 1rem 0.93rem'
                    }}
                    disabled={
                        Object.values(payload).some(
                            (item) => item === undefined
                        ) ||
                        Object.values(errors).some((item) => item.length > 0) ||
                        loading
                    }
                    buttonText='Save as'
                />
            </form>
        </div>
    );
};

export default Savetradedocument;
